import common from './common.js';

import header from './template-parts/header.js';
import footer from './template-parts/footer/container.js';

import search from './template-parts/search.js';

import carousels from './carousels.js';

ScrollTrigger.config({
  ignoreMobileResize: true
});

Vlitejs.registerProvider('youtube', VlitejsYoutube);

gsap.registerPlugin(ScrollTrigger, SplitText, CustomEase);

CustomEase.create('homeIntroEase', 'M0,0 C0.71,0 0.22,1 1,1');
CustomEase.create('locationsIntroEase', 'M0,0 C0.81,0 0.17,1 1,1');

const app = {
  init() {
    common.init();

    carousels.init(); // needs to init before the footer because footer has a carousel

    header.init();
    footer.init();

    search.init();

    this.setUpListeners();
    this.setUpGclid();
  },

  resizeTimeout: null,
  lastWidth: window.innerWidth,
  setUpListeners() {
    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        if (this.lastWidth !== window.innerWidth) {
          this.lastWidth = window.innerWidth;
          PubSub.publish('resize.x');
        } else {
          PubSub.publish('resize.xy');
        }
      }, 100);
    });

    setTimeout(() => {
      if (window.location.hash) {
        const $elToScrollTo = document.querySelector(window.location.hash);
        if ($elToScrollTo) {
          $elToScrollTo.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
      }
    }, 100);

    document.addEventListener('DOMContentLoaded', this.setUpGclid.bind(this));
    document.addEventListener('frmPageChanged', this.setUpGclid.bind(this));
  },

  setUpGclid() {
    const gclidFromUrl = this.getUrlParam('gclid');
    let gclid = sessionStorage.getItem('gclid');

    if (gclidFromUrl) {
      gclid = gclidFromUrl;
      sessionStorage.setItem('gclid', gclidFromUrl);
      console.log('GCLID set from url', gclidFromUrl);
    }

    if (gclid) {
      console.log('GCLID found', gclid);
      const gclidInputs = document.querySelectorAll('input[type="hidden"][name^="item_meta"][id*="gclid"]');

      console.log('Forms with GCLID', gclidInputs);

      gclidInputs.forEach(input => {
        if (!input.value || input.value !== gclid) {
          input.value = gclid;
          input.setAttribute('data-frmval', gclid);
          console.log('GCLID set', gclid);
        }
      });
    }
  },

  getUrlParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }
};

app.init();
